import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { Route, useHistory } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
// Material Ui
// ## //

const LoggedInRoute = ({ component, lazyComponent, childProps, ...rest }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const isLoggedIn = useSelector((state) => state.auth.loggedIn)

  useEffect(() => {
    if (!isLoggedIn) {
      // set the current url/path for future redirection (we use a Redux action)
      // then redirect (we use a React Router method)
      const currentURL = history.location.pathname
      if (currentURL !== "/login") {
        history.push("/login", { from: currentURL })
      }
    }
  }, [dispatch, history, isLoggedIn])

  if (isLoggedIn) {
    return (
      <Route
        {...rest}
        render={(routeProps) => {
          const Component = lazyComponent ? lazyComponent() : component
          return <Component {...rest} {...routeProps} {...childProps} />
        }}
      />
    )
  }
  return null
}

LoggedInRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  lazyComponent: PropTypes.func,
  childProps: PropTypes.object
}

LoggedInRoute.defaultProps = {
  childProps: {},
  component: undefined,
  lazyComponent: undefined
}

export default LoggedInRoute
